/* INN7 P/4 display-only helpers. Native option IDs and native theme selection remain authoritative. */
(() => {
  const ringHandles = new Set(['parts-of-four-giant-roman', 'parts-of-four-ronam-ring', 'parts-of-four-sahara-ring', 'parts-of-four-chasm-ring', 'parts-of-four-sistema-ring-40414', 'parts-of-four-plane-ring', 'parts-of-four-sistema-ring-40313']);
  if (!customElements.get('p4-ring-selection')) {
    customElements.define('p4-ring-selection', class extends HTMLElement {
      async connectedCallback() {
        const repair = this.querySelector('input[data-p4-repair-selection]:checked');
        const picker = this.closest('variant-picker');
        if (!repair || !picker || !ringHandles.has(picker.getAttribute('handle'))) return;
        await customElements.whenDefined('variant-picker');
        // Native connectedCallback has now bound the form, including on quick-buy/section replacements.
        await new Promise(resolve => requestAnimationFrame(resolve));
        if (!this.isConnected || !repair.checked || picker.selectedVariant?.available !== false) return;
        const form = document.forms[picker.getAttribute('form-id')];
        if (!form) return;
        const preventPendingSubmit = event => { event.preventDefault(); event.stopImmediatePropagation(); };
        form.addEventListener('submit', preventPendingSubmit, true);
        picker.setAttribute('aria-busy', 'true');
        try {
          const optionValues = Array.from(form.elements)
            .filter(input => input.matches('input[data-option-position]:checked'))
            .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
            .map(input => input.value);
          await picker.selectCombination({ optionValues, productChange: false });
        } catch (error) {
          console.error('P/4 native size selection could not be refreshed.', error);
        } finally {
          form.removeEventListener('submit', preventPendingSubmit, true);
          picker.removeAttribute('aria-busy');
        }
      }
    });
  }
  if (!customElements.get('p4-size-filter')) {
    customElements.define('p4-size-filter', class extends HTMLElement {
      connectedCallback() {
        const form = this.closest('form');
        const toggle = this.querySelector('[data-p4-filter-toggle]');
        const raw = Array.from(this.querySelectorAll('input[data-p4-raw-value]'));
        if (!form || !toggle || !raw.length || !/\/collections\/parts-of-four(?:\/[^/]+)?\/?$/.test(new URL(form.action).pathname)) return;
        this.querySelector('[data-p4-filter-ui]').hidden = false;
        this.querySelector('[data-p4-filter-native]').hidden = true;
        this._abort = new AbortController();
        // Set both raw values before the native facets-form change listener builds FormData.
        this.addEventListener('change', event => {
          if (event.target !== toggle) return;
          raw.forEach(input => { input.checked = toggle.checked; });
        }, { capture: true, signal: this._abort.signal });
      }
      disconnectedCallback() { this._abort?.abort(); }
    });
  }
})();
